<div class="hpanel margin-bottom-5 contact-panel" [ngClass]="{'deactivated': isDeactivated}">
  <div class="panel-body pd-15 minheight165 couers border-radius-top-left-right-6 border-radius-bottom-left-right-0">
    <div title="{{ userDataInput.teamName }}">
      <div (click)="visitTeam(userDataInput)">
        <div class="" style="cursor: pointer">
          <h6 class="cardEillpise card-title-font font-bold" style="text-transform: capitalize;"
            title="{{ userDataInput.teamName }}">{{ userDataInput.teamName }}</h6>
          <p class="font-bold cardEillpise card-subtitle-font by-position" title="{{userDataInput.name}}"
            *ngIf="userDataInput.teamsOwnerId!=userId"> By {{userDataInput.adminUserData.fullName}}</p>
        </div>
      </div>
    </div>
    <div class="flt-rtt6"
      *ngIf="acceptRejectBtn === 'true' && (userDataInput?.status !== 'DEACTIVATED' && userDataInput?.status !== 'INACTIVE') || (userDataInput.memberStatus === 'RequestsReceived' && userDataInput?.status !== 'DEACTIVATED' && userDataInput?.status !== 'INACTIVE')">
      <button type="button" class="btn  btn-primary b-5  btn-xs"
        (click)="accept(userDataInput);$event.stopPropagation();">Accept</button>
      <div class="btn-group three_icon_cmon1 hovers" dropdown>
        <a id="button-animated" dropdownToggle class="m-r-10">
          <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dote">
        </a>
        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu m-l-81 card-dropdown" role="menu"
          style="left: auto;" aria-labelledby="button-animated">
          <li role="menuitem">
            <a class="dropdown-item common-font-12 padd" (click)="reject(userDataInput)">Reject</a>
          </li>
        </ul>
      </div>

    </div>
    <div class="flt-rtt col-sm-6">
      <div *ngIf="userDataInput.teamsOwnerId==userId"><img class="crown" title="Owner" src="assets/icon/crown_.PNG"
          alt=""></div>
      <div *ngIf="userDataInput.teamsOwnerId === userId&&userDataInput?.status !== 'INACTIVE'" class="btn-group">
        <img mat-icon-button [matMenuTriggerFor]="menu" src="assets/icon/icon-vert-thr-dot.png" alt="" class="Vthree-dote">

        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngIf="userDataInput?.status === 'ACTIVE'" (click)="mgsBtn(userDataInput)">
            Message
          </button>
          <button mat-menu-item *ngIf="userDataInput?.status === 'ACTIVE'"
            (click)="deleteTeam(userDataInput, 'delete')">
            Deactivate Workspace
          </button>
          <button mat-menu-item *ngIf="['DEACTIVATED'].includes(userDataInput?.status)"
            (click)="activateTeam(userDataInput)">
            Activate Workspace
          </button>
        </mat-menu>
      </div>



      <div
        *ngIf="userDataInput.memberType=='MEMBER' && acceptRejectBtn!='true' && userDataInput.memberStatus=='ACTIVE' && userDataInput?.status=='ACTIVE'"
        class="btn-group" dropdown>
        <a id="button-animated" dropdownToggle class="m-r-10">
          <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dot1">
        </a>

        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu m-l-81 card-dropdown" role="menu"
          style="right: 0;left: auto;" aria-labelledby="button-animated">
          <li role="menuitem"><a class="dropdown-item" (click)="mgsBtn(userDataInput)"> Message</a></li>
          <li role="menuitem"><a class="dropdown-item" (click)="deleteTeam(userDataInput, 'leave')"> Leave Workspace</a>
          </li>
        </ul>
      </div>
    </div>
    <div style="padding-bottom: 64px;display: flex;" (click)="visitTeam(userDataInput)">

      <div class="margin-l-20" *ngIf="stopcheckbox">
        <div class="custom-checkbox">
          <label class="checkbox-label font-normal">
            <input type="checkbox" [(ngModel)]="userDataInput.isSelected"
              [disabled]="showCheckBox != 0 && (showCheckBox >0 && userDataInput.isSelected==false) "
              (ngModelChange)="onNgModelChange($event , userDataInput?.teamId)" name="list_name" />
            <span class="checkmark" style="top: -5px"></span>
          </label>
        </div>
      </div>

      <ng-container *ngFor="let member of userDataInput.members;let i = index;">
        <img [ngClass]="{'deactivated': isDeactivated}" *ngIf="i<5 && member.image != null && member.image != undefined"
          alt="logo" class="img-circle mt-5 netCard" src="{{member.image}}" />

        <div class="mt-5 netCard" [ngClass]="{'deactivated': isDeactivated}"
          *ngIf="i<5 && (member.image == null || member.image == undefined)">
          <div class="circles h-w-32" [style.background-color]="getColortwo(member?.firstName, member?.lastName)">
            <div class="circle-text ft-16 pd-tp-2" [style.color]="getTextColor(member?.firstName, member?.lastName)">{{
              getInitialstwo(member?.firstName,
              member?.lastName) }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- [ngClass]="{'qwpoi': userDataInput.memberType!='OWNER'}" -->
    <div class="qwpoi1"
      *ngIf="['DEACTIVATED', 'INACTIVE'].includes(userDataInput?.status)||userDataInput?.memberStatus === 'INACTIVE'">
      <img height="25px" src="assets/icon/Blocked-PNG-File.png" alt="" (click)="$event.stopPropagation();">
      <div class="display-grid">
        <p class="deactivated" *ngIf="userDataInput?.status === 'DEACTIVATED'">Deactivated</p>
        <p class="deactivated" *ngIf="userDataInput?.status === 'INACTIVE'">Inactive</p>
        <p class="no-longer-member" *ngIf=" userDataInput?.memberStatus === 'INACTIVE'">Access restricted</p>
      </div>
    </div>
  </div>
  <div class="row panel-footer contact-footer p-0 m-0 br-bot-0">
    <div class="col-md-4 p-0">
      <div class="contact-stat">
        <span>Post </span>
        <strong>{{userDataInput.postCnt}}</strong>
      </div>
    </div>
    <div class="col-md-4 p-0 couers"
      [ngClass]="{'deactivated': ['DEACTIVATED', 'INACTIVE'].includes(userDataInput?.status)}"
      (click)="redirectPage(userDataInput)">
      <div class="contact-stat">
        <span>Member </span>
        <strong>{{userDataInput.memberCnt}}</strong>
      </div>
    </div>
    <div class="col-md-4 p-0">
      <div class="contact-stat">
        <span>Views </span> <strong>{{userDataInput.viewCnt}}</strong>
      </div>
    </div>
  </div>
</div>